<template lang="pug">
    div          
        v-row
            v-spacer
            v-col( cols="3" sm="12" md="3")
                    v-text-field(   label="Nombre Tipo"
                                    placeholder="Nombre....."
                                    outlined    
                                    v-model="parameter.Name"
                                    @keypress.enter="sendSearch()") 
            v-col( cols="3" sm="12" md="3")
                    v-select(   label="Estado"
                                outlined
                                :items="ItemValues"
                                item-text="text"
                                item-value="value"
                                v-model="parameter.Active" )          
            v-col( cols="2" sm="12" md="2")
                    v-btn(color="primary" @click="sendSearch()" block large) Buscar 
                        i.fa.fa-search  
        v-row    
            v-col( cols="12" sm="12" md="12")
                    v-simple-table(class="elevation-5" )
                            thead(class="elevation-1"  ) 
                                tr
                                    th Editar
                                    th Nombre Tipo 
                                    th (Activado) Preguntas
                                    th (Activado) Items
                                    th (Activado) Respuesta No Conformidades
                                    th (Activado) Geolocalizacion
                                    th (Activado) Responsable
                                    th Estado
                                    th Configuracion  
                            tbody                      
                                tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo" :key="index")
                                        td
                                            v-chip-group 
                                                v-icon.fa.fa-edit(elevation="10" color="info" @click="sendInfo(item)")  
                                                v-icon.fa.fa-trash(elevation="10" color="error" @click="sendDelete(item)")    
                                        td {{item.Name}} 
                                        td {{item.ActiveQuestions==1 ? 'Activo':'Inactivo'}}
                                        td {{item.ActiveItems==1 ? 'Activo':'Inactivo'}}
                                        td {{item.ActiveAnswerNonconformities==1 ? 'Activo':'Inactivo'}}
                                        td {{item.ActiveGeolocation==1 ? 'Activo':'Inactivo'}}
                                        td {{item.ActiveResponsible==1 ? 'Activo':'Inactivo'}}
                                        td {{item.Active==1 ? 'Activo':'Inactivo'}}
                                        td 
                                            v-icon.fa.fa-gears(elevation="10" color="warning" @click="sendInfoDinamic(item)")   


</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    data(){
        return{
            ItemValues:[
                        {value:0, text:'Activa'},
                        {value:1, text:'Inactiva'},
                        {value:2, text:'Todos'}
                    ]
        }
    },
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            },
            sendInfoDinamic(item){  
             ///   this.$emit("sendInfoDinamic", Object.assign({}, item)) 
             this.$router.push({path:'/docConfig', query : { item: item }} )

            },
            sendDelete(item){
                 this.$emit("sendDelete", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>